import React from 'react';
import moment from "moment";
import * as utils from "../../../utils/utils";

export default class Date extends React.Component {
    render() {
        return <span>{utils.notNullNorUndefined(this.props.row.creation_date) && moment.unix(this.props.row.creation_date).format('DD/MM/Y')}</span>;
    }
}


// WEBPACK FOOTER //
// ./src/components/fog/tableComponents/Date.js